import { BaseModel } from "./BaseModel";

export class ApiResult
{

    public success: boolean = false;

}
